import { render, staticRenderFns } from "./icon-xls.vue?vue&type=template&id=f440612e&"
import script from "./icon-xls.vue?vue&type=script&lang=js&"
export * from "./icon-xls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports